<template>
  <div>
    <b-modal
        ref="modal"
        size="lg"
        hide-footer
        title="Detalhes de Sincronização"
        centered
        dialog-class="sync-view-modal"
    >
      <div class="d-flex justify-content-between align-items-start mb-2 modal-header-inline">
        <div>
          <h5 class="mb-0">Manual</h5>
          <small class="text-muted">Status por unidade</small>
        </div>
      </div>

      <div
          v-if="loading"
          class="d-flex flex-column align-items-center justify-content-center loading-area"
      >
        <b-spinner small type="grow" class="mb-2"/>
        <span>Carregando dados de sincronização...</span>
      </div>

      <div v-else>
        <div
            v-if="!syncData.length"
            class="text-center py-4 text-muted"
        >
          Nenhum dado de sincronização encontrado
        </div>

        <div v-else>
          <b-list-group>
            <b-list-group-item
              v-for="(unit, idx) in syncData"
              :key="idx"
              class="d-flex flex-column sync-item"
            >
              <div class="d-flex justify-content-between align-items-center mb-1">
                <strong>{{ unit.unidade_nome || 'N/A' }}</strong>
                <div>
                  <i v-if="unit.sincronizado" class="fas fa-check-circle text-success fa-lg" title="Sincronizado"></i>
                  <i v-else class="fas fa-times-circle text-danger fa-lg" title="Não sincronizado"></i>
                </div>
              </div>
              <div class="small text-muted">
                <span class="label">Última sincronização:</span>
                <span>{{ unit.sincronizado_em ? formatDate(unit.sincronizado_em) : 'Nunca' }}</span>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import {
  BModal,
  BSpinner,
  BListGroup,
  BListGroupItem
} from 'bootstrap-vue';

export default {
  name: 'ManualSyncView',
  components: {
    BModal,
    BSpinner,
    BListGroup,
    BListGroupItem
  },
  data() {
    return {
      syncData: [],
      loading: false
    };
  },
  methods: {
    open(manualId) {
      this.syncData = [];
      this.loading = true;
      this.$refs.modal.show();

      const api = this.$store.state.api + `manuais/${manualId}/sync-status`;
      axios.get(api)
          .then(response => {
            const data = response.data.data || response.data || [];
            this.syncData = Array.isArray(data) ? data : [];
          })
          .catch(error => {
            this.$message && this.$message("Erro", "Erro ao carregar dados de sincronização", "error");
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        return date.toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return dateString;
      }
    }
  },
};
</script>

<style scoped>
.sync-view-modal .modal-header-inline {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.loading-area {
  min-height: 200px;
}

.sync-item {
  margin-bottom: 0.5rem;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.sync-item:hover {
  background-color: #f8f9fa;
}

.label {
  font-weight: 600;
  margin-right: 0.5rem;
}

@media (max-width: 768px) {
  .modal-header-inline {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
